var map = {
	"./CommonListenLrResult.vue": 45177,
	"./CommonReadRrResult.vue": 6532,
	"./CommonSpeakingKtResult.vue": 18040,
	"./CommonSpeakingLdldResult.vue": 5864,
	"./CommonSpeakingTyResult.vue": 87747,
	"./CommonTranslationTsResult.vue": 47404,
	"./CommonWriteKwResult.vue": 10977,
	"./CommonWriteMsResult.vue": 45982,
	"./CommonWritePaResult.vue": 26262,
	"./CommonWritePuResult.vue": 1195,
	"./CommonWriteSxResult.vue": 77388
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32779;